/**
 * Shared helpers for react-select–shaped options: `{ label, value }`.
 */

/**
 * @param {Array<{ label: string, value: string }> | undefined} options
 * @param {string | null | undefined} value
 * @returns {{ label: string, value: string } | undefined}
 */
export function findSelectOptionByValue(options, value) {
  if (value == null || value === '' || !options?.length) return undefined;
  return options.find((o) => o.value === value);
}
